module.exports = {
  messages: {
    CN: {
      content: '首页',
      description: '这是一个演示页面'
    },
    HK: {
      content: '首頁',
      description: '這是一個演示頁面'
    },
    US: {
      content: 'First Page',
      description: 'This is a demo page'
    }
  }
}